<template>
  <!-- 文章详情 -->
  <div class="my-articleDetail">
    <!-- 文章详情 -->
    <div class="title">
      {{ defaultProxyDetails && defaultProxyDetails.title }}
    </div>
    <div class="article-main">
      <img :src="defaultProxyDetails && defaultProxyDetails.icon" alt="">
      <div v-html="defaultProxyDetails.content"></div>
    </div>
    <returnBack></returnBack>
    <footerCom :defaultProxyDetails="defaultProxyDetails" @handleLike="handleLike" @handleCollect="handleCollect" @handleNext="handleNext"></footerCom>
  </div>
</template>
<script>
import returnBack from '@/views/person/components/returnBack.vue'
import { getProxyMobileDetails, articleUnLike, articleLike, articleUserCollect, articleUnUserCollect } from '@/api/article'
import footerCom from '@/views/article/components/footerCom.vue'
import MxTcVideo from '@/views/article/MxTcVideo'

function getURLParameters (url) {
  const params = {}
  const regex = /[?&]([^=#]+)=([^&#]*)/g
  let match

  while ((match = regex.exec(url)) !== null) {
    params[match[1]] = match[2]
  }
  return params
}

export default {
  name: 'ArticleDetails',
  mixins: [MxTcVideo],
  components: {
    returnBack,
    footerCom
  },
  data() {
    return {
      proxyId: '',
      defaultProxyDetails: {},
      defaultProxyDetailsId: '',
    }
  },
  computed: {
    userInfo() {
      return this.$store.getters.userInfo
    }
  },
  mounted() {
    this.proxyId = this.$route.query.id
    this.handleLoad()
  },
  methods: {
    /**
     * @method
     * @name: _handleRichVideo
     * @description: 处理富文本视频
     * @param: {Function} [playFn] 视频播放
     * {String} [content] parent
     */
    _handleRichVideo ({
      eachFn,
    } = {}) {
      let videos = []
      this.$nextTick(() => {
        videos = document.querySelectorAll(`.edui-upload-video`)
        console.log(videos, '=-')
        videos.forEach((video, index) => {
          if (eachFn && typeof eachFn === 'function') {
            eachFn(video, index, index === videos.length - 1)
          }
        })
      })
      return videos
    },
    handleLoad() {
      getProxyMobileDetails(this.proxyId).then(res => {
        this.defaultProxyDetails = res.data
        this.defaultProxyDetailsId = res.data.id
        this._handleRichVideo({
          eachFn: async (video, index, isLast) => {
            const id = `rich-video-${index}`
            video.setAttribute('id', id)
            let data = getURLParameters(video.src)
            if (!data.poster && video.getAttribute('poster')) data.poster = video.poster
            this.initVideo(id, data)
          }
        })
      })
    },
    handleNext(val) {
      getProxyMobileDetails(val).then(res => {
        this.defaultProxyDetails = res.data
        this.defaultProxyDetailsId = res.data.id
      })
    },
    // 点赞
    handleLike() {
      if (this.defaultProxyDetails.isLike) {
        const params = {
          userId: this.userInfo.id,
          baseId: this.defaultProxyDetailsId,
          type: 6,
          kind: 6
        }
        articleUnLike(params).then(res => {
          if (res.code === 0) {
            this.handleLoad()
          }
        })
      } else {
        const params = {
          type: 6,
          likeId: this.defaultProxyDetailsId,
          likeTitle: this.defaultProxyDetails.title,
          userId: this.userInfo.id,
          openId: this.userInfo.iepOpenId,
          cover: this.defaultProxyDetails.icon,
          kind: 6,
        }
        articleLike(params).then(res => {
          if (res.code === 0) {
            console.log('🚀 ~ articleLike ~ res:', res)
            this.handleLoad()
          }
        })
      }
    },
    // 收藏
    handleCollect() {
      if (this.defaultProxyDetails.isCollect) {
        const params = {
          baseId: this.defaultProxyDetailsId,
          baseType: 6,
          userId: this.userInfo.id,
          userName: this.userInfo.realName
        }
        articleUnUserCollect(params).then(res => {
          if (res.code === 0) {
            this.handleLoad()
          }
        })
      } else {
        const params = {
          userId: this.userInfo.id,
          baseId: this.defaultProxyDetailsId,
          baseType: 6,
        }
        articleUserCollect(params).then(res => {
          if (res.code === 0) {
            this.handleLoad()
          }
        })
      }
    },
  }
}
// 这块是路由跟踪埋点的功能，具体实现在utils/withRouteTracking.js
</script>
<style lang="less" scoped>
.my-articleDetail{
  background: url('../../assets/images/article/articleDetails-bg.png') no-repeat center center / 100% 100%;
  min-height: 100vh;
  width: 100vw;
  position: relative;
  display: flex;
  flex-direction: column;
  .title{
    padding:16px 16px 12px;
    font-weight: 600;
    font-size: 16px;
    color: #333333;
    line-height: 20px;
    text-align: left;
  }
  .article-main{
    margin:12px;
    padding:8px;
    height: calc(100vh - 160px);
    background: #fff;
    box-shadow: 0px 0px 4px 0px rgba(0,0,0,0.08);
    border-radius: 8px;
    overflow-y: auto;
    img{
      width: 100%;
      margin-bottom: 8px;
    }
    .desc{
      font-family: Source Han Sans CN, Source Han Sans CN;
      font-weight: 400;
      font-size: 14px;
      color: #333333;
      line-height: 21px;
    }
    .pd8{
      padding-bottom: 8px;
    }
  }
}
</style>
<style lang="less">
.article-main {
  span {
    text-wrap: auto!important;
  }
  .raw-image {
    width: 100%!important;
    display: block;
  }
  img{
    width: 100%!important;
    margin-bottom: 8px;
  }
  .edui-upload-video {
    width: 100%!important;
    height: 250px;
    display: block;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/xwzy/articleDetails.vue